var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPathCornerTl = function SvgPathCornerTl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 10 30 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v10q0 30 29 30"
  })));
};
export default SvgPathCornerTl;